// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__NOBBf","container":"Landing_container__0eenF"};